import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import Title from "../UI/Title/title"
import {
  frontendTechs,
  backendTechs,
  databaseTechs,
  languages,
  otherTechs,
} from "../../constants/skills"

import classes from "./skills.module.scss"

const Skills = props => {
  const { t } = useTranslation()

  return (
    <section className={classes.SkillsSection}>
      <Title type="primary">{props.title}</Title>
      <div className={classes.Center}>
        <div className={classes.Frontend}>
          <h3>{t("skillsSection.skillTypes.frontend")}</h3>
          <div>
            {frontendTechs.map(tech => (
              <div key={tech.id} className={classes.Skill}>
                {tech.icon}
                <p>{tech.title}</p>
              </div>
            ))}
          </div>
        </div>

        <div className={classes.Languages}>
          <h3>{t("skillsSection.skillTypes.language")}</h3>
          <div>
            {languages.map(tech => (
              <div key={tech.id} className={classes.Skill}>
                {tech.icon}
                <p>{tech.title}</p>
              </div>
            ))}
          </div>
        </div>

        <div className={classes.Backend}>
          <h3>{t("skillsSection.skillTypes.backend")}</h3>
          <div>
            {backendTechs.map(tech => (
              <div key={tech.id} className={classes.Skill}>
                {tech.icon}
                <p>{tech.title}</p>
              </div>
            ))}
          </div>
        </div>

        <div className={classes.Database}>
          <h3>{t("skillsSection.skillTypes.database")}</h3>
          <div>
            {databaseTechs.map(tech => (
              <div key={tech.id} className={classes.Skill}>
                {tech.icon}
                <p>{tech.title}</p>
              </div>
            ))}
          </div>
        </div>

        <div className={classes.Others}>
          <h3>{t("skillsSection.skillTypes.other")}</h3>
          <div>
            {otherTechs.map(tech => (
              <div key={tech.id} className={classes.Skill}>
                {tech.icon}
                <p>{tech.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Skills

// const Skills = props => {
//   return (
//     <section className={classes.SkillsSection}>
//       <Title type="primary">{props.title}</Title>
//       <div className={classes.Center}>
//         <div className={classes.Skills}>
//           {technologies.map(tech => (
//             <div key={tech.id} className={classes.Skill}>
//               {tech.icon}
//               <p>{tech.title}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   )
// }
